import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class GoalsController extends Controller {
  @service
  strings;
}
